// @ts-nocheck
/**
 * Journey Slideshow - Enhanced scroll control and animations
 * Provides smooth scroll hijacking and advanced GSAP animations
 */

gsap.registerPlugin(ScrollTrigger);

let allowScroll = true;
let scrollTimeout = gsap.delayedCall(1, () => allowScroll = true).pause();
let currentIndex = 0;
let lastMotion = 'down';
let swipePanels = gsap.utils.toArray(".journey-slideshow .journey-slide");
let slideTransitionDuration = 1.5;

// Set z-index levels for the swipe panels
gsap.set(swipePanels, { zIndex: i => swipePanels.length - i});
gsap.set(swipePanels, { opacity: 1}); // We set opacity after zIndex to reduce loading flicker

// Create a scroll observer and disable it until the no-scroll zone is reached
let preventScroll = ScrollTrigger.observe({
  type: "wheel,touch,pointer,scroll",
  onDown: () => allowScroll && gotoPanel(currentIndex - 1, false),
  onUp: () => allowScroll && gotoPanel(currentIndex + 1, true),
  wheelSpeed: -1,
  tolerance: 10,
  preventDefault: true,
  onEnable(self) {
    allowScroll = false;
    scrollTimeout.restart(true);
    // when enabling, we should save the scroll position and freeze it. This fixes momentum-scroll on Macs, for example.
    let savedScroll = self.scrollY();
    self._restoreScroll = () => self.scrollY(savedScroll); // if the native scroll repositions, force it back to where it should be
    document.addEventListener("scroll", self._restoreScroll, {passive: false});
  },
  onDisable: self => document.removeEventListener("scroll", self._restoreScroll)
});
preventScroll.disable();


// gotoPanel: Handles the panel swipe animations
function gotoPanel(index, isScrollingDown) {
  // return to normal scroll if we're at the end or back up to the start
  if ((index === swipePanels.length && isScrollingDown) || (index === -1 && !isScrollingDown)) {
    preventScroll.disable(); // resume native scroll
    return;
  }

  lastMotion = isScrollingDown ? 'down' : 'up';
  allowScroll = false;
  scrollTimeout.restart(true);
  let isMobile = window.matchMedia("(max-width: 749px)").matches;

  let target = isScrollingDown ? swipePanels[currentIndex] : swipePanels[index];
  if((index === swipePanels.length-1 && isScrollingDown) || (index === swipePanels.length-2 && !isScrollingDown)) {
    // Last panel transition uses a swipe effect and faster speed
    gsap.to(target, { 
      yPercent: isScrollingDown ? -100 : 0, 
      duration: 1, 
    });
  } else {
    // Default transition is fade
    gsap.to(target, { autoAlpha: isScrollingDown ? 0 : 1, duration: slideTransitionDuration });
  }

  /* Additional animations for certain transitions */
  // If we are moving from index 0 to 1 add a zoom and position effect to the foreground image
  slideOneXOffset = isMobile ? 0 : 250;
  slideOneYOffset = isMobile ? -250 : -200;
  slideOneScale = isMobile ? 1.6 : 2;
  slideTwoXOffset = isMobile ? 65 : -40;
  slideTwoYOffset = isMobile ? 46 : 60;
  slideTwoScale = isMobile ? 3.1 : 2.5;
  if (currentIndex === 0 && index === 1) {
    gsap.fromTo(swipePanels[0].querySelector(".journey-slide__foreground"), {
      scale: 1,
      y: 0,
      x: 0
    }, {
      scale: slideOneScale,
      y: slideOneYOffset,
      x: slideOneXOffset,
      duration: slideTransitionDuration,
      ease: "power2"
    });
  }
  // If we are moving from 1 to 0 play the animation in reverse
  else if (currentIndex === 1 && index === 0) {
    gsap.fromTo(swipePanels[0].querySelector(".journey-slide__foreground"), {
      scale: slideOneScale,
      y: slideOneYOffset,
      x: slideOneXOffset
    }, {
      scale: 1,
      y: 0,
      x: 0,
      duration: slideTransitionDuration,
      ease: "power2"
    });
  }
  // If we are moving from 1 to 2 add a zoom and position effect to the foreground image
  else if (currentIndex === 1 && index === 2) {
    gsap.fromTo(swipePanels[1].querySelector(".journey-slide__foreground"), {
      scale: 1,
      y: 0,
      x: 0
    }, {
      scale: slideTwoScale,
      y: slideTwoYOffset,
      x: slideTwoXOffset,
      duration: slideTransitionDuration,
      ease: "power2"
    });
  }
  // If we are moving from 2 to 1 play the animation in reverse
  else if (currentIndex === 2 && index === 1) {
    gsap.fromTo(swipePanels[1].querySelector(".journey-slide__foreground"), {
      scale: slideTwoScale,
      y: slideTwoYOffset,
      x: slideTwoXOffset
    }, {
      scale: 1,
      y: 0,
      x: 0,
      duration: slideTransitionDuration,
      ease: "power2"
    });
  }

  currentIndex = index;

  // Some cleanup steps to make sure the page exists when we are approaching the end of the no-scroll zone
  if(currentIndex == 2 && lastMotion === 'down') {
    restorePageBelow();
  }
  if(currentIndex == 1 && lastMotion === 'up') {
    hidePageBelow();
  }
}


// pin swipe section and initiate observer
ScrollTrigger.create({
  trigger: ".journey-slideshow",
  pin: true,
  pinSpacing: false,
  start: "top 1px",
  end: "+=20", // just needs to be enough to not risk vibration where a user's fast-scroll shoots way past the end
  onEnter: (self) => {
    if (preventScroll.isEnabled) { return } // in case the native scroll jumped past the end and then we force it back to where it should be.
    self.scroll(self.start + 1); // jump to just one pixel past the start of this section so we can hold there.
    preventScroll.enable(); // STOP native scrolling

    if (currentIndex == 0) {
      // Auto advance the first panel
      gotoPanel(1, true);
    }
  },
  onEnterBack: (self) => {
    if (preventScroll.isEnabled) { return } // in case the native scroll jumped backward past the start and then we force it back to where it should be.
    self.scroll(self.end - 1); // jump to one pixel before the end of this section so we can hold there.
    preventScroll.enable(); // STOP native scrolling
  }
});


// On page load, temporarily hide the bottom of the page to prevent overscroll when entering the no scroll zone
function hidePageBelow() {
  // Hide the custom section below the slideshow
  document.querySelector('.custom-section-content').style.display = 'none';
  // Hide the footer
  document.querySelector('footer').style.display = 'none';
  pageBelowHidden = true;
}

function restorePageBelow() {
  // Show the custom section below the slideshow
  document.querySelector('.custom-section-content').style.display = 'block';
  // Show the footer
  document.querySelector('footer').style.display = '';
  pageBelowHidden = false;
}

// First determine how far down the page we are scrolled when the page loads
let scrollY = window.scrollY || window.pageYOffset;
let pageBelowHidden = false;

// If we are less than 100, we should hide the sections and divs below the journey slide show and hide the footer temporarily until the observer is enabled
if (scrollY < 100) {
  hidePageBelow();
}

